import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Models
import mCompany from 'models/company';
// Custom
import { getCompanies, deleteCompany, addCompanySetParent } from 'actions';
import { companiesShape } from 'constants/PropTypesShapes';
import { addPath, navigateToAdd } from 'companies/navigation';
import { AddTextButton, RefreshTextButton } from 'components/buttons/TextButtons';
import MainViewTemplate from 'components/templates/MainViewTemplate';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withTitle from 'hocs/WithTitle';
import CompanyItem from 'companies/assets/main/CompanyItem';

class CompaniesList extends React.Component {
  constructor(props) {
    super(props);

    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    this.doGetCompanies();
  }

  componentDidUpdate(prevProps) {
    const { deleted } = this.props;
    if (!prevProps.deleted && deleted) {
      this.doGetCompanies();
    }
  }

  // Handlers
  handleRefresh() {
    this.doGetCompanies();
  }

  handleAdd(company) {
    const { handleAddCompanySetParent } = this.props;
    // Store parent company
    handleAddCompanySetParent(company);
    navigateToAdd();
  }

  handleDelete(company) {
    const { handleDisplayConfirm, handleDeleteCompany } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteCompany', values: { companyName: company.name } },
      () => handleDeleteCompany(company.id),
    );
  }

  // Private
  doGetCompanies() {
    const { handleGetCompanies } = this.props;
    handleGetCompanies();
  }

  render() {
    const { companies: { loading, elements } } = this.props;
    const sortedCompanies = mCompany.sortElements(elements);

    return (
      <MainViewTemplate
        title={<LocalizedMessage id="title.companiesList" />}
        icon={mCompany.icon}
        buttons={[
          <AddTextButton primary key="add" path={addPath()} />,
          <RefreshTextButton key="refresh" primary onClick={this.handleRefresh} />,
        ]}
        withPadding
        withDivider
      >
        <LoadingDisplayer loading={loading}>
          <div className="row">
            {!!sortedCompanies && _map(sortedCompanies, (company) => (
              <div key={_toString(company.id)} className="col-12 col-md-6 col-xl-4 pt-4">
                <CompanyItem
                  company={company}
                  withActions
                  onAdd={this.handleAdd}
                  onDelete={this.handleDelete}
                />
              </div>
            ))}
          </div>
          {!sortedCompanies
            && <div style={{ height: '150px' }} />}
        </LoadingDisplayer>
      </MainViewTemplate>
    );
  }
}

CompaniesList.propTypes = {
  companies: companiesShape.isRequired,
  deleted: PropTypes.bool.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetCompanies: PropTypes.func.isRequired,
  handleDeleteCompany: PropTypes.func.isRequired,
  handleAddCompanySetParent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  companies: state.company.list,
  deleted: state.company.delete.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetCompanies: () => {
    dispatch(getCompanies());
  },
  handleDeleteCompany: (id) => {
    dispatch(deleteCompany(id));
  },
  handleAddCompanySetParent: (company) => {
    dispatch(addCompanySetParent(company));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirmDialog,
  withTitle('pageTitle.companies'),
)(CompaniesList);



// WEBPACK FOOTER //
// ./routes/app/routes/companies/routes/list/components/CompaniesList.js